// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@shared/types/db';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://bkemtxuxwbccpgylbdod.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJrZW10eHV4d2JjY3BneWxiZG9kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY2MDk4NzUsImV4cCI6MjA2MjE4NTg3NX0.ErUUQUt8o0GLclfD26XgCA8FbPBPNweGidftzI-VbEg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);